import { render, staticRenderFns } from "./ShoeImgs.vue?vue&type=template&id=6d8fe069&scoped=true&"
import script from "./ShoeImgs.vue?vue&type=script&lang=js&"
export * from "./ShoeImgs.vue?vue&type=script&lang=js&"
import style0 from "./ShoeImgs.vue?vue&type=style&index=0&id=6d8fe069&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d8fe069",
  null
  
)

export default component.exports